import { css } from 'styled-components';
import { BadgeColorMap, BadgeStateColorMap } from './consts';
import { StatusType } from '../types';
import {
  BadgeProperties,
  BetaBadgeProperties,
  DefaultOrScenarioBadgeProperties,
  InteractiveBadgeProps,
  InteractiveBetaBadgeProperties,
  ReadonlyBadgeProps,
} from './types';
import { ICON_SELECTOR } from '@ardoq/icons';

const composeCssColorBlock = ({
  color,
  backgroundColor,
  borderColor,
  iconColor,
}: BadgeStateColorMap) => css`
  ${color &&
  css`
    color: ${color};
  `};
  ${backgroundColor &&
  css`
    background-color: ${backgroundColor};
  `}
  ${borderColor &&
  css`
    border-color: ${borderColor};
  `}
  ${iconColor &&
  css`
    ${ICON_SELECTOR} {
      color: ${iconColor};
    }
  `}
`;

export const composeCssStatesColorBlock = (colorMap: BadgeColorMap) => css`
  ${composeCssColorBlock(colorMap.default)}
`;

export const isInteractiveBadge = (
  badge: BetaBadgeProperties
): badge is InteractiveBetaBadgeProperties => {
  const interactive = badge as InteractiveBetaBadgeProperties;
  return (
    interactive.knowledgeBaseUrl !== undefined ||
    interactive.shareFeedbackUrl !== undefined ||
    interactive.changelogUrl !== undefined ||
    interactive.openOnboardingModal !== undefined ||
    interactive.onTakeTour !== undefined
  );
};

export const isScenarioOrDefaultBadge = (
  badge: BadgeProperties
): badge is DefaultOrScenarioBadgeProperties =>
  badge.statusType === StatusType.DEFAULT ||
  badge.statusType === StatusType.SCENARIO;

export const isInteractiveBadgeProps = (
  badgeProps: ReadonlyBadgeProps | InteractiveBadgeProps
): badgeProps is InteractiveBadgeProps =>
  (badgeProps as InteractiveBadgeProps).type === 'interactive';

export const toInteractiveBadgeProps = (
  status: 'beta' | 'new' | 'trial',
  options: InteractiveBadgeProps['options']
): InteractiveBadgeProps => ({
  type: 'interactive',
  statusType:
    status === 'beta'
      ? StatusType.BETA
      : status === 'new'
        ? StatusType.NEW
        : StatusType.TRIAL,
  options,
});
